// import { coursesSlide } from "./scripts/slick";
import { handleMenuMobile } from "./scripts/menu";
import { handleMenu } from "./scripts/menu";
import { smoothInternalLink } from "./scripts/smooth-internal-links";
// import { coursesSlide } from "./scripts/swiper";

// coursesSlide();
// handleMenuMobile();
// handleMenu();
smoothInternalLink();
